import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Alert
} from "reactstrap";
import { Formik, Form, Field } from "formik";
import ClearableField from "./ClearableField";

const apiCalls = require("../../ApiCalls");

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      errorMsg: "",
      success: false
    };

    this.handleBack = this.handleBack.bind(this);
  }

  handleSubmit = (values, {resetForm}) => {
    apiCalls.createUser(values).then(
      result => {
        if (!result.success) {
          this.setState({
            error: true,
            errorMsg: result.errMsg,
            success: false
          });
        } else {
          this.setState({
            success: true,
            username: values.username,
            error: false,
            errorMsg: ''
          })
          resetForm();
          this.props.history.push('./admin')
        }
      })
      .catch(err => {
        this.props.handleAPIError(err);
      })
  };

  handleBack = () => {
    this.props.history.push('/admin');
  }

  isNotEmail = (value) => {
    return !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
  }

  validate = values => {
    const errors = {};
    if (!values.email) {
      errors.email = "Required";
    } else if (this.isNotEmail(values.email)) {
      errors.email = "Invalid email address";
    }

    if (!values.username) {
      errors.username = "Required";
    } else if (this.isNotEmail(values.username)) {
      errors.username = "Username must be an email address";
    }

    if (!values.firstName) {
      errors.firstName = "Required";
    }

    if (!values.lastName) {
      errors.lastName = "Required";
    }

    if (!values.password) {
      errors.password = "Required";
    }

    if (!values.passwordConfirm) {
      errors.passwordConfirm = "Required";
    } else if(values.passwordConfirm !== values.password) {
      errors.passwordConfirm = "Password does not match";
    }

    return errors;
  };

  render() {
    return (
      <Formik
        initialValues={{
          username: "",
          firstName: "",
          lastName: "",
          email: "",
          password: "",
          passwordConfirm: ""
        }}
        validate={this.validate}
        onSubmit={this.handleSubmit}
        render={({ errors, status, touched }) => (
          <div className="app flex-row align-items-center">
            <Container>
              <Row className="justify-content-center">
                {this.state.error ? (
                  <Alert color="danger">{this.state.errorMsg}</Alert>
                ) : null}
                {this.state.success ? (
                  <Alert color="success">User {this.state.username} has been created.</Alert>
                ) : null}
              </Row>
              <Row className="justify-content-center">
                <Col md="6">
                  <Card className="mx-4">
                    <CardBody className="p-4">
                      <Form>
                        <h1>Register</h1>
                        <p className="text-muted">Create your account</p>
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-user"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <ClearableField
                            id="username"
                            name="username"
                            type="text"
                            placeholder="Username"
                            autoComplete="username"
                          />
                          {errors.username && touched.username && <div className="invalid-feedback">{errors.username}</div>}
                        </InputGroup>
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-user"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <ClearableField
                            id="firstName"
                            name="firstName"
                            type="text"
                            placeholder="First name"
                            autoComplete="firstName"
                          />
                          {errors.firstName && touched.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
                        </InputGroup>
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-user"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <ClearableField
                            id="lastName"
                            name="lastName"
                            type="text"
                            placeholder="Last name"
                            autoComplete="lastName"
                          />
                          {errors.lastName && touched.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
                        </InputGroup>
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>@</InputGroupText>
                          </InputGroupAddon>
                          <ClearableField
                            placeholder="Email"
                            autoComplete="email"
                            id="email"
                            name="email"
                            type="text"
                          />
                          {errors.email && touched.email && <div className="invalid-feedback">{errors.email}</div>}
                        </InputGroup>
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-lock"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <ClearableField
                            type="password"
                            placeholder="Password"
                            autoComplete="new-password"
                            id="password"
                            name="password"
                          />
                          {errors.password && touched.password && <div className="invalid-feedback">{errors.password}</div>}
                        </InputGroup>
                        <InputGroup className="mb-4">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-lock"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <ClearableField
                            type="password"
                            placeholder="Repeat password"
                            autoComplete="new-password"
                            id="passwordConfirm"
                            name="passwordConfirm"
                          />
                          {errors.passwordConfirm && touched.passwordConfirm && <div className="invalid-feedback">{errors.passwordConfirm}</div>}
                        </InputGroup>
                        <Button type="submit" color="success" block>
                          Create Account
                        </Button>
                        <Button onClick={this.handleBack} block>
                          Back
                        </Button>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        )}
      />
    );
  }
}

export default Register;
